// extracted by mini-css-extract-plugin
export default {"componentsWrapper":"Components_componentsWrapper__zs10p"};